// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const DAY_IN_SECOND = 24 * 60 * 60;
export const COOKIE_DOMAIN = import.meta.env.REACT_APP_MODE === 'next' ? '' : '.rango.exchange';

export const GTM_COOKIE_NAME = [
  { name: 'googleAnalytics', value: '_ga' },
  { name: 'beamer', value: '_BEAMER' },
  { name: 'general clarity', value: '_clsk' },
  { name: 'general clarity', value: '_clck' },
  { name: 'CLID clarity', value: 'CLID' },
  { name: 'MUID clarity', value: 'MUID' },
];

export const COOKIE_CONSENT_VALUE = {
  granted: 'granted',
  denied: 'denied',
};

export const PRIVY_APP_ID = import.meta.env.REACT_APP_PRIVY_APP_ID || '';
